import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const QuizResultViewScreen = lazy(() => import('../../screens/QuizResult/screens/View'));

const userQuizResultsRoutes = [
    <Route
        exact
        key={routes.QUIZ_RESULTS_LIST}
        path={routes.QUIZ_RESULTS_LIST}
        render={() => (
            <Authenticated redirectTo={routes.USER_LIST}>
                <QuizResultViewScreen />
            </Authenticated>
        )}
    />,
];

export default userQuizResultsRoutes;
